define('model/copyright/copyrightCaption',["../selector"], function (selector) {
    "use strict";
    return function (json) {
        return selector(json, "copyrightsCaption");
    };
});

